import asyncActionTypes from '../actions/types';

const initialState = {
  refundCode96Dot5: false,
};

const refundCode96Dot5 = (
  state = initialState,
  action = null / undefined
) => {
  switch (action.type) {
    case asyncActionTypes.SET_REFUND_CODE_96_5.START:
      return {
        refundCode96Dot5: initialState.setRefund,
      };
    case asyncActionTypes.SET_REFUND_CODE_96_5.SUCCESS:
      return {
        refundCode96Dot5: action?.payload,
      };
    case asyncActionTypes.SET_REFUND_CODE_96_5.FAIL:
      return {
        refundCode96Dot5: initialState.setRefund,
      };
    default:
      return state;
  }
};

export default refundCode96Dot5;
